import { useField } from "formik";
import React from "react";
import { renderErrorMessage } from "./Tools";

export function Textarea(props: {
  fieldName: string;
  placeholder?: string;
  className?: string;
  type?: string;
  textboxIcon?: React.ReactNode;
  isDisabled?: boolean;
  textRows?: number;
  maxLength?: number;
}) {
  const [field, meta] = useField(props.fieldName);
  return (
    <div className="field">
      <div className="control">
        <textarea
          maxLength={props.maxLength}
          rows={props.textRows || 6}
          className="textarea"
          placeholder={props.placeholder}
          disabled={props.isDisabled}
          {...field}
          value={field.value || ""}
        />
        {renderErrorMessage(meta)}
      </div>
    </div>
  );
}
